import { Button, Form, Input, Modal, Spin, Upload } from 'antd'
import { ExclamationCircleOutlined, InboxOutlined } from '@ant-design/icons'
import React, { useState } from 'react'
import { connect } from 'react-redux'
import { actions } from '../../../../../../../../store/reducers/assignments.reducer'

const { Dragger } = Upload

const UploadSubmissionsZip = ({ excelFiles, setExcelSubmissionsZipFile, uploadExcelAssignment }) => {
    const [form] = Form.useForm()

    const [isWaitingForUpload, setIsWaitingForUpload] = useState(false)

    const onUpload = async () => {
        setIsWaitingForUpload(true)
        await uploadExcelAssignment(form.getFieldValue('assignmentName'))
        setIsWaitingForUpload(false)
    }

    const draggerFileList = []
    if (excelFiles.submissionsZip) draggerFileList.push(excelFiles.submissionsZip)

    const draggerProps = {
        name: 'file',
        accept: '.zip',
        multiple: false,
        listType: 'picture',
        maxCount: 1,
        fileList: draggerFileList,
        beforeUpload: file => {
            if (excelFiles.submissionsZip) {
                Modal.confirm({
                    title: 'Confirm replacement',
                    icon: <ExclamationCircleOutlined />,
                    content: (
                        <div
                            dangerouslySetInnerHTML={{
                                __html: `You have already selected <code>${excelFiles.submissionsZip.name}</code> file. Are you sure that you want to replace it?`,
                            }}
                        />
                    ),
                    okText: 'Confirm',
                    onOk() {
                        setExcelSubmissionsZipFile(file)
                    },
                    cancelText: 'Cancel',
                })
            } else {
                setExcelSubmissionsZipFile(file)
            }
            return false
        },
        onRemove() {
            setExcelSubmissionsZipFile(null)
        },
    }

    return (
        <Spin spinning={isWaitingForUpload}>
            <Form
                name='upload-excel-submissions-zip'
                autoComplete='off'
                form={form}
                layout='vertical'
                requiredMark={false}
                onFinish={onUpload}
            >
                <Form.Item
                    label='Assignment name'
                    name='assignmentName'
                    rules={[{ required: true, message: 'Please, enter assignment name' }]}
                >
                    <Input />
                </Form.Item>
                <Form.Item
                    name='excelSubmissionsZipFile'
                    valuePropName='excelSubmissionsZipFile'
                    rules={[
                        {
                            message: 'Please, select ZIP file with submission files',
                            validator: () => {
                                if (excelFiles.submissionsZip) {
                                    return Promise.resolve()
                                } else {
                                    return Promise.reject('Some message here')
                                }
                            },
                        },
                    ]}
                >
                    <Dragger {...draggerProps} aria-label='Submission files'>
                        <p className='ant-upload-drag-icon'>
                            <InboxOutlined />
                        </p>
                        <p className='ant-upload-text'>Click or drag ZIP with submission files to this area</p>
                    </Dragger>
                </Form.Item>
                <Form.Item>
                    <Button type='primary' htmlType='submit' loading={isWaitingForUpload} block>
                        Create
                    </Button>
                </Form.Item>
            </Form>
        </Spin>
    )
}

const mapState = ({ assignments }) => {
    return {
        excelFiles: assignments.excelFiles,
    }
}

const mapDispatch = dispatch => {
    return {
        setExcelSubmissionsZipFile(value) {
            return dispatch(actions.setExcelSubmissionsZipFile(value))
        },
        uploadExcelAssignment(assignmentName) {
            return dispatch(actions.uploadExcelAssignment(assignmentName))
        },
    }
}

export default connect(mapState, mapDispatch)(UploadSubmissionsZip)
